import React from "react";
import t from "../utils/t";
import SimpleModal from "./SimpleModal";

interface IProps {
    onClose(): void;
}

export default class ServerErrorModal extends React.Component<IProps> {
    public render(): JSX.Element {
        const { onClose } = this.props;
        return (
            <SimpleModal
                title={ t("LOGIN_REQUIRED_MODAL.TITLE") }
                message={ t("LOGIN_REQUIRED_MODAL.MESSAGE") }
                onClose={ onClose.bind(this) }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LoginRequiredModal.tsx